import { getFillByLot } from "../manzanas/Manzana2Div1";

export const Manzana91Div1M2 = ({
  lands,
  landSelector = (_e, _id) => {},
  selected,
  style,
}) => {
  const findLandByLot = (lot) => {
    return lands.filter((l) => l.lote === lot)[0];
  };

  if (!lands) {
    return <></>;
  }

  return (
    <svg 
    width={style?.width || "1219"}
    height={style?.height || "941"}
    viewBox="0 0 1221 921" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg">
  <rect width="1221" height="921" fill="url(#pattern0_1461_7010)"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}
      d="M569.668 784.497C555.258 736.463 543.65 678.421 539.647 655.404L504.622 662.409C515.83 701.638 552.656 760.146 569.668 784.497Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}
      d="M532.638 599.361L539.643 655.402L504.617 662.407L484.603 606.366L532.638 599.361Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}
      d="M529.637 552.328L532.639 599.362L484.605 606.367L474.598 558.332L529.637 552.328Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}
      d="M468.591 515.304L474.595 558.335L529.635 552.33V511.301L468.591 515.304Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}
      d="M467.591 470.271L468.592 515.304L529.636 511.301L530.637 474.274L467.591 470.271Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}
      d="M468.592 429.238L467.591 470.268L530.637 474.271C530.637 464.664 537.975 447.585 541.645 440.246L468.592 429.238Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}
      d="M557.655 414.232L541.643 440.25L468.591 429.243L472.594 396.219L557.655 414.232Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}
      d="M580.673 386.207L557.656 414.227L512.624 404.22L537.642 343.176L580.673 386.207Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}
      d="M614.698 357.187L580.673 386.208L537.642 343.177L572.667 309.152L614.698 357.187Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}
      d="M528.637 245.105L572.669 309.152L552.654 328.165L502.618 288.136C510.624 265.72 523.3 250.109 528.637 245.105Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}
      d="M484.603 342.176C490.207 316.557 498.947 295.475 502.616 288.137L552.652 328.166L537.641 343.176L532.638 354.184L484.603 342.176Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}
      d="M472.595 396.215L484.603 342.176L532.638 354.184L512.624 404.22L472.595 396.215Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <defs>
    <pattern id="pattern0_1461_7010" patternContentUnits="objectBoundingBox" width="1" height="1">
    <use href="#image0_1461_7010" transform="matrix(0.00137265 0 0 0.00181977 -2.9495 -1.39563)"/>
    </pattern>
    <image id="image0_1461_7010" width="4096" height="2304" href="/mz2.png"/>
    </defs>
    </svg>

  );
};